<template>
	<transition enter-active-class="animated zoomIn">
		<div id="app">
			<div id="content">
				<img src="../../assets/img/logo.png" width="70px" height="auto" style="margin-left: 25px;margin-right: 15px;margin-top: 15.5px;"/>
                <div style="float: left;margin-top: 7px;">
                    <span class="id" style="line-height: 66px;">象和•多领域融合气象服务平台</span>
                    <!-- <span class="id" style="margin-left: 10px;font-size: 13px;">Sun yat-sen University Typhoon Research Platform</span> -->
                </div>
                <!-- <br> -->
                <!-- <span class="id" style="margin-left: 10px">Sun yat-sen University Typhoon Research Platform</span> -->
                <div class="formDiv">
					<Icon type="md-person" size="20" color="rgb(1 250 254)" />
					<Button
						type="text"
						size="small"
						style="color:rgb(1 250 254)"
						@click="openModel"
					>{{ userName != "" ? userName : "登录" }}</Button>
					<Button
						type="text"
						size="small"
						style="color:rgb(1 250 254)"
						@click="closeAdmin"
						v-show="!userName == ''"
					>退出</Button>
					<!-- <Button type="text" size="small" color="white" @click="openModel" v-show="!userName == ''">修改密码</Button> -->
				</div>
				<ul id="menu">
					<li>
						<router-link tag="a" to="/huananForecast" exact>台风预报</router-link>
					</li>
					<!-- <li>
						<router-link tag="a" to="/weatherFacts">实况与预报</router-link>
					</li> -->
					<li>
						<router-link tag="a" to="/waveForecast">海洋预报</router-link>
					</li>
					<li>
						<router-link tag="a" to="/airportForecast">机场预报</router-link>
					</li>
          			<li v-show="UserLevel == '1'">
						<router-link tag="a" to="/setting">系统管理</router-link>
					</li>
				</ul>
			</div>
			<div id="content-body">
				<Weathermap v-on:getMap="getMap" id="map" v-show="$store.state.rutePath != '/setting'"></Weathermap>
				<!-- <transition  :duration="{ enter: 900, leave: 500 }" mode="out-in" enter-active-class="animated zoomIn" leave-active-class="animated flipOutX"> -->
				<transition enter-active-class="animated zoomIn">
					<router-view></router-view>
				</transition>
			</div>
		</div>
	</transition>
</template>

<script type="text/ecmascript-6">
import Weathermap from "@/map/weathermap.vue";
export default {
	name: 'App',
	components: {
		Weathermap
	},
	data() {
		return {
			userName: '',
			formInline: {
				user: '',
				password: ''
			},
			ruleInline: {
				user: [{ required: true, message: '请输入用户名', trigger: 'blur' }],
				password: [{ required: true, message: '请输入密码', trigger: 'blur' }]
			},
			loading1: false,
      UserLevel: null
		}
	},
	methods: {
		//获取白板图组件的地图对象
		getMap(data) {
			this.map = data;
			this.$store.state.map = this.map;
			this.map.zoomToScale(1 / 12000000, true);
		},
		closeAdmin() {
			localStorage.setItem('userName', '');
			this.userName = '';
			this.$router.push("/sign");
		},
		openModel() {
			if (this.userName != '') {
				return
			} else {
				this.formModel = true
			}
		},
		sign() {
			this.loading1 = true
			setTimeout(() => {
				this.loading1 = false
			}, 3000)
		}
	},
	mounted() {},
	created() {
    this.UserLevel = localStorage.getItem('UserLevel');
    this.userName = localStorage.getItem('userName');
	},
	destroyed: function() {
	}
}
</script>

<style>
*{
    outline: none;
}
#app {
	font-family: 'Avenir', Helvetica, Arial, sans-serif;
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
	text-align: center;
	width: 100%;
	height: 100%;
}
html,
body {
	width: 100%;
	height: 100%;
}
body {
	background-size: cover;
	font-family: 'Microsoft YaHei', 微软雅黑, SimSun, 宋体, sans-serif;
	margin: 0;
	padding: 0;
}
ul li {
	list-style: none;
	padding: 0;
	margin: 0;
}
#content {
	width: 100%;
	height: 80px;
	min-width: 950px;
	background: rgb(10,33,64);
	overflow: hidden;
}
#content img {
	float: left;
}
.id {
	color: white;
	font-size: 30px;
}
#menu {
	float: right;
	width: auto;
	list-style: none;
	line-height: 80px;
	margin-right: 20px;
}
#menu li {
	float: left;
	width: 132px;
	display: grid;
    margin-left: 15px
}
#menu li a {
	float: left;
	font-size: 20px;
	color: rgb(4,144,159);
	text-decoration: none;
}
#menu li a:hover {
    color: rgb(1,250,254);
	background-image: url('../../assets/img/dt.png');
	background-position-y: 11px;
    background-position-x: -18px;
}
#content-body {
	width: 100%;
	height: calc(100% - 80px);
	overflow: auto;
}
#menu .is-active {
    color: rgb(1,250,254);
	background-image: url('../../assets/img/dt.png');
	background-position-y: 11px;
    background-position-x: -18px;
}
.formDiv {
    margin-right: 20px;
	line-height: 80px;
    float: right;
}
</style>



// WEBPACK FOOTER //
// src/framework/pc/Menu.vue